import React, { Component, } from 'react';
import { func, object, } from 'prop-types';
import styled from 'styled-components';
// import { func } from  'prop-types';
import { connect, } from 'react-redux';

import Input from '../../legacy-tv-ui/Input';
import Widget from '../../legacy-tv-ui/Widget';
import Grid from '@material-ui/core/Grid';
import { USERS_MAP, } from '../../constant';
import { setErrMsg, resetErrMsg, } from '../../actions';
import Button from '../../components/Button';

const InputContainer = styled.div`
  width: 200px;
  margin: 0 auto;
`;
const MainContainer = styled.div`
  position: fixed;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
`;

export class Home extends Component {
  static propTypes = {
    setErrMsg: func.isRequired,
    resetErrMsg: func.isRequired,
    history: object.isRequired,
  }
  static defaultProps = {}
  constructor(props) {
    super(props);
    this.state = {
      projectId: '',
    };
  }
  componentDidMount() {
    const input = document.getElementById('id-input');
    input && input.focus();
  }
  updateInput = (key, value) => {
    this.setState({
      [key]: value,
    });
  }
  handleSubmit = (e) => {
    e.preventDefault();
    const { projectId, } = this.state;
    if (!USERS_MAP[projectId]) {
      this.props.setErrMsg('查無查代號，請重新輪入');
      return;
    }
    this.props.resetErrMsg();
    this.props.history.push('/' + projectId + '/date-select');
  }
  render() {
    return (
      <MainContainer>
        <Grid container>
          <Grid item xs={12} sm={3} lg={4} />
          <Grid item xs={12} sm={6} lg={4}>
            <Widget
              title="請輸入公司代碼"
              style={
                {
                  marginTop: 100,
                  textAlign: 'center',
                }
              }
            >
              <form onSubmit={this.handleSubmit}>
                <InputContainer>
                  <Input
                    id="id-input"
                    style={{ marginBottom: 10, }}
                    placeholder=""
                    value={this.state.projectId}
                    onChange={e => this.updateInput('projectId', e.target.value)}
                  />
                </InputContainer>
                {
                  this.state.projectId &&
                  <Button type="submit">
                    送出
                  </Button>
                }
              </form>
            </Widget>
          </Grid>
        </Grid>
      </MainContainer>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

const dispatchObj = {
  setErrMsg,
  resetErrMsg,
};

export default connect(mapStateToProps, dispatchObj)(Home);



// WEBPACK FOOTER //
// ./src/scenes/Home/index.js